import { cn as r } from "../../utils/utils.js";
import { jsx as t } from "react/jsx-runtime";
function d({ className: e, ...i }) {
  return /* @__PURE__ */ t("input", {
    "data-slot": "input",
    className: r("flex h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40", e),
    ...i
  });
}
export {
  d as Input
};

//# sourceMappingURL=input.js.map